import React from "react";
import { useFormContext } from "react-hook-form";
import { Dialog, Form } from "@sscs/ui";
import { PURL_SAFE_HELP_MESSAGE } from "Constants";
import { PackageFormData } from "Types";

const Package = (): React.JSX.Element => {
  const { formState } = useFormContext<PackageFormData>();

  return (
    <Dialog.Section>
      <Dialog.Section.Title>Create package</Dialog.Section.Title>
      <Dialog.Section.Description>
        Imported software always goes into a new package. The package receives
        its versions from the external catalog and cannot receive manual
        uploads.
      </Dialog.Section.Description>
      <Dialog.Section.Content>
        <Form.TextField
          id="package-name"
          name="package_name"
          label="Package name"
          helperText={PURL_SAFE_HELP_MESSAGE}
          errors={formState.errors}
        />
        <Form.TextArea
          id="package-description"
          name="package_description"
          label="Short description"
          errors={formState.errors}
        />
      </Dialog.Section.Content>
    </Dialog.Section>
  );
};

export default Package;
